<mat-sidenav-container fullscreen>
	<mat-sidenav
		mode="side"
		#sidenav
		[mode]="mobile.matches ? 'over' : 'side'"
		[opened]="!mobile.matches"
		[fixedInViewport]="mobile.matches"
	>
		<div class="logotype">
			<img alt="logo" src="./assets/media/logos/logo-cream.svg" />
		</div>
		<mat-nav-list
			id="main-menu"
			(click)="mobile.matches && sidenav.close()"
		>
			<a
				(click)="
					openLink('https://sites.google.com/newproperty.se/info')
				"
				mat-list-item
				><i class="fas fa-fw fa-info-circle"></i> Info</a
			>
			<a
				mat-list-item
				[routerLink]="['/overview']"
				routerLinkActive="active"
				><i class="fas fa-fw fa-satellite"></i> Översikt</a
			>
			<a
				mat-list-item
				*ngIf="users.hasRole('item_user')"
				[routerLink]="['/items']"
				[queryParams]="{ state: 'available' }"
				routerLinkActive="active"
				><i class="fas fa-fw fa-building"></i> Lediga objekt</a
			>
			<a
				mat-list-item
				class="sublink"
				*ngIf="users.hasRole('item_user')"
				[routerLink]="['/items']"
				[queryParams]="{
					user: users.me?.id || 0,
					state: 'new-available'
				}"
				routerLinkActive="active"
				><i class="fas fa-fw fa-empty"></i> Mina objekt</a
			>
			<a
				mat-list-item
				*ngIf="users.hasRole('item_user')"
				routerLink="/map"
				[queryParams]="{ state: 'new-available' }"
				routerLinkActive="active"
				><i class="fas fa-fw fa-map"></i> Karta</a
			>
			<a
				mat-list-item
				*ngIf="users.hasRole('item_user')"
				[routerLink]="['/prospects']"
				routerLinkActive="active"
				><i class="fas fa-fw fa-home"></i> Prospekt</a
			>
			<a
				mat-list-item
				[routerLink]="['/leads']"
				[queryParams]="{ user: users.me?.id || 0, state: 'open' }"
				routerLinkActive="active"
				*ngIf="users.hasRole('item_user')"
				><i class="fas fa-fw fa-envelope"></i> Intressenter</a
			>
			<a
				mat-list-item
				routerLink="/invoices"
				[queryParams]="{ user: users.me?.id || 0, state: 'any' }"
				queryParamsHandling=""
				routerLinkActive="active"
				*ngIf="users.hasRole('item_user') || users.hasRole('salary_user')"
				><i class="fas fa-fw fa-file"></i> Fakturor</a
			>
			<a
				mat-list-item
				[routerLink]="['/salary', users.me?.id || 0]"
				routerLinkActive="active"
				*ngIf="users.hasRole('salary_user')"
				><i class="fas fa-fw fa-money-bill"></i> Min lön</a
			>
			<a
				mat-list-item
				routerLink="/salary/generate"
				routerLinkActive="active"
				*ngIf="users.hasRole('salary_admin')"
				><i class="fas fa-fw fa-money-bill"></i> Lönekörning</a
			>
			<a
				mat-list-item
				routerLink="/companies"
				routerLinkActive="active"
				*ngIf="users.hasRole('salary_admin')"
				><i class="fas fa-fw fa-gavel"></i> Bolag</a
			>
			<a
				mat-list-item
				routerLink="/users"
				routerLinkActive="active"
				*ngIf="users.hasRole('user_admin') || users.hasRole('user_manager')"
				><i class="fas fa-fw fa-users"></i> Användare</a
			>
			<a
				mat-list-item
				routerLink="/stats/users"
				routerLinkActive="active"
				*ngIf="users.hasRole('stats_users')"
				><i class="fas fa-fw fa-table"></i> Statistik</a
			>
			<a
				(click)="
					openLink('https://drive.google.com/drive/folders/0AOV2eZu1sKi0Uk9PVA')
				"
				mat-list-item
				*ngIf="users.hasRole('item_user')"
				><i class="fas fa-fw fa-folder"></i> Dokument</a
			>
			<a
				mat-list-item
				(click)="openLink('https://newproperty.pipedrive.com')"
				><i class="fas fa-fw fa-envelope"></i> Pipedrive</a
			>
			<a
				mat-list-item
				(click)="openLink('https://avtal.newproperty.se/')"
				><i class="fas fa-fw fa-file-contract"></i> Avtal</a
			>
			<a mat-list-item (click)="openLink('mailto:it@newproperty.se')"
				><i class="fas fa-fw fa-question-circle"></i> Support</a
			>
			<a mat-list-item routerLink="/auth/login" routerLinkActive="active"
				><i class="fas fa-fw fa-sign-out-alt"></i> Logga ut</a
			>
		</mat-nav-list>
		<div class="footer">
			<p *ngIf="error" class="test-version-notice">
				{{ error }}
			</p>
			<p *ngIf="testVersion" class="test-version-notice">
				<span class="badge badge-warning">Testversion</span>
			</p>
			<p>
				&copy;&nbsp;{{ today | date : "yyyy" }}&nbsp;Elmér S<span
					(click)="overrideAuth()"
					>o</span
				>lutions
			</p>
		</div>
	</mat-sidenav>
	<mat-sidenav-content [class.is-mobile]="mobile.matches">
		<div class="main-menu-toggle" *ngIf="mobile.matches">
			<button (click)="sidenav.open()">
				<i class="fas fa-bars"></i>
			</button>
			<img
				alt="New Property"
				class="text-logo"
				src="./assets/media/logos/text-light.svg"
			/>
		</div>
		<div class="main-content">
			<router-outlet></router-outlet>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
